module.exports = __webpack_public_path__ + "static/make-sense-logistics-277eaabc0df127e59bae96e64ce35038.png";